import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTerminal } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';
import { MetaTitle } from '../components/MetaTitle';

const Home = () => {
  return (
    <div className="">
      <MetaTitle title="Home" />
      <p className="h1 text-amber-500 mb-4">
        <FontAwesomeIcon icon={faTerminal} />
      </p>

      <p className="text-lg">Hello, I'm Dave.</p>

      <p>
        I'm a dedicated and experienced senior frontend software engineer based
        in Brighton, UK, and I&apos;m passionate about creating
        high-performance, user-friendly web applications.
      </p>

      <p>
        Check out my{' '}
        <NavLink to="/work" className="text-amber-500">
          work history
        </NavLink>{' '}
        to see if I can help you build something great.
      </p>
    </div>
  );
};

export default Home;
